import React from 'react';
import {RichText,Text} from '@sitecore-jss/sitecore-jss-react';


const AccordionItem = ({fields, index, handleClick, isActive}) => {
	const accordionItemIdObj = (fields.accordionItemID.value) ? {id: fields.accordionItemID.value} : {};
	return fields.accordionItemTitle.value ? (
		<div className={`accordion-item accordion-item-${index}`} {...accordionItemIdObj}>
			<div role="presentation" className="accordion-item-title">
				<button
					type="button"
					className={`accordion-trigger ${isActive ? 'active' : ''}`}
					aria-expanded={isActive}
					aria-disabled={false}
					tabIndex="0"
					id={`accordion-${index}`}
					aria-controls={`accordion-panel-${index}`}
					onClick={handleClick}
				>
					<Text className="accordion-header-link" field={fields.accordionItemTitle} />
				</button>
			</div>
			<div
				className={`accordion-item-description accordion-item-first ${
					isActive ? 'expanded' : 'notExpanded'
				}`}
			>
				<div
					id={`accordion-panel-${index}`}
					role="region"
					className="accordion-panel"
					aria-labelledby={`accordion-${index}`}
				>
					<RichText field={fields.accordionItemBody} />
				</div>
			</div>
		</div>
	) : null;
};

export default AccordionItem;
